module.exports = {"disclaimer":"","agree":"","disagree":"","disagreeText":"","newCalculation":"","profiletype":"","profile_id":"","steelquality_id":"","protectionfront":"","protectionback":"","norm_id":"","lifespan":"","front_corrosion_id":"","front_mm_total":"","front_mm_rate":"","back_corrosion_id":"","back_mm_total":"","back_mm_rate":"","projectnaam":"","naam":"","firma":"","emailadres":"","optin":""}


//////////////////
// WEBPACK FOOTER
// ./src/assets/translations_fr.json
// module id = 203
// module chunks = 0